import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { ToastrModule } from "ngx-toastr";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from "./app-routing.module";
import { MatDialogModule } from "@angular/material/dialog";

// import { NgxOwlModule } from 'ngx-owl-carousel';

import { AppComponent } from "./app.component";
import { ShopComponent } from "./shop/shop.component";
import { PagesComponent } from "./pages/pages.component";
import { ElementsComponent } from "./elements/elements.component";
import { AdminEditorComponent } from "./admin-editor/admin-editor.component";
import { QuillModule } from 'ngx-quill';
import { RangePipe } from "./range.pipe";
import { InterviewerLoginComponent } from "./interviewer/interviewer-login/interviewer-login.component";
import { CommonLandingPageComponent } from "./home/common-landing-page/common-landing-page.component";
import { AuthInterceptorService } from "./services/interceptors/auth-interceptor.service"
import { IdleDialogComponent } from "./feature/idle-dialog/idle-dialog.component";
import { ImmediateHiringsComponent } from "./immediate-hirings/immediate-hirings.component";
import { PlansPriceComponent } from "./admin/plans-price/plans-price.component";
import { MatTabsModule } from "@angular/material/tabs";
import { VendorSuccessPageComponent } from "./vendor/vendor-success-page/vendor-success-page.component";
import { AdvertiseDetailsViewComponent } from "./advertise-details-view/advertise-details-view.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { FaqsComponent } from "./faqs/faqs.component";
import { DetailBlogViewComponent } from "./detail-blog-view/detail-blog-view.component";
import { ValidatePaymentsComponent } from "./validate-payments/validate-payments.component";
import { PlanDetailPageComponent } from "./admin/plans-price/plan-detail-page/plan-detail-page.component";
import { HeaderLatestComponent } from "./home/landing-root/header-latest/header-latest.component";
import { FooterMoreInfoComponent } from "./home/landing-root/footer-more-info/footer-more-info.component";
import { RippleLoaderComponent } from "./ripple-loader/ripple-loader.component";
import { VerifyVendorEmailComponent } from "./vendor/verify-vendor-email/verify-vendor-email.component";
import { ChatWidgetComponent } from "./shared/components/widgets/chat-widget/chat-widget.component";
import { MatNativeDateModule } from "@angular/material/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { SpinnerLoaderComponent } from "./services/spinner-loader/spinner-loader.component";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { JobSeekerModule } from "./job-seeker/job-seeker/job-seeker.module";
import { JobLandingComponent } from "./job-landing/job-landing.component";
import { FullCalendarModule } from '@fullcalendar/angular';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        ShopComponent,
        PagesComponent,
        ElementsComponent,
        RangePipe,
        IdleDialogComponent,
        ImmediateHiringsComponent,
        PlansPriceComponent,
        VendorSuccessPageComponent,
        AdvertiseDetailsViewComponent,
        FaqsComponent,
        DetailBlogViewComponent,
        ValidatePaymentsComponent,
        PlanDetailPageComponent,
        RippleLoaderComponent,
        SpinnerLoaderComponent,
        JobLandingComponent
        // ChatWidgetComponent
        // PlansRootComponent/

    ],
    bootstrap: [AppComponent],
    imports:
        [
            BrowserModule.withServerTransition({ appId: "serverApp" }),
            BrowserAnimationsModule,
            NgbModule,
            LoadingBarHttpClientModule,
            LoadingBarRouterModule,
            AppRoutingModule,
            ToastrModule.forRoot({
                timeOut: 3000,
                progressBar: false,
                enableHtml: true,
            }),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            SharedModule,
            AppRoutingModule,

            CommonLandingPageComponent,
            MatDialogModule,
            MatTabsModule,
            MatFormFieldModule,
            MatDatepickerModule,
            MatIconModule,
            HeaderLatestComponent,
            FooterMoreInfoComponent,
            MatNativeDateModule,
            ReactiveFormsModule,
            MatInputModule,
            MatProgressSpinnerModule,
            FullCalendarModule

        ],
    providers: [
        DatePipe, {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ],

})
export class AppModule { }
